import { Car, Factory, Globe, Mountain, Tractor, Truck } from "lucide-react";
import { Chapter, FadeIn } from "./Reveal";
import { CERTS, SECTORS } from "../data/site";

const ICONS = { Truck, Tractor, Car, Mountain, Factory, Globe };

export const Clients = () => (
    <section
        id="clients"
        data-testid="clients-section"
        className="border-t border-line py-28 md:py-40"
    >
        <div className="mx-auto max-w-screen-2xl px-6 md:px-12">
            <Chapter number="05" label="Clients & Certifications" />
            <div className="mb-14 grid gap-10 md:mb-20 lg:grid-cols-12">
                <FadeIn className="lg:col-span-7">
                    <h2 className="font-display text-4xl uppercase leading-[0.95] tracking-tight text-zinc-100 md:text-6xl">
                        Trusted on <span className="text-ember">every axle</span> we ship
                    </h2>
                </FadeIn>
                <FadeIn delay={0.1} className="flex items-end lg:col-span-5">
                    <p className="text-sm leading-relaxed text-zinc-400 md:text-base">
                        We supply reputed OEMs and Tier-1 manufacturers across India, and
                        export to markets in Asia, Europe and the Middle East. Names stay
                        confidential — the parts speak for themselves.
                    </p>
                </FadeIn>
            </div>

            <div className="grid gap-px border border-line bg-line sm:grid-cols-2 lg:grid-cols-3">
                {SECTORS.map((s, i) => {
                    const Icon = ICONS[s.icon];
                    return (
                        <FadeIn key={s.name} delay={(i % 3) * 0.08} className="group bg-ink">
                            <div
                                data-testid={`sector-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                className="flex items-center justify-between p-6 transition-colors duration-300 group-hover:bg-coal md:p-8"
                            >
                                <span className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-300">
                                    {s.name}
                                </span>
                                <Icon
                                    size={22}
                                    strokeWidth={1.5}
                                    className="text-zinc-600 transition-colors group-hover:text-ember"
                                />
                            </div>
                        </FadeIn>
                    );
                })}
            </div>

            <div className="mt-4 grid gap-px border border-line bg-line md:grid-cols-2">
                {CERTS.map((c, i) => (
                    <FadeIn key={c.code} delay={i * 0.1} className="bg-coal/60">
                        <div
                            data-testid={`cert-${c.code.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            className="flex flex-col gap-3 p-8 md:flex-row md:items-center md:justify-between md:p-10"
                        >
                            <span className="font-display text-3xl uppercase tracking-tight text-zinc-100 md:text-4xl">
                                {c.code}
                            </span>
                            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-ember md:text-xs">
                                {c.label}
                            </span>
                        </div>
                    </FadeIn>
                ))}
            </div>
        </div>
    </section>
);
